import { render, staticRenderFns } from "./editdialog.vue?vue&type=template&id=457e9dda&scoped=true"
import script from "./editdialog.vue?vue&type=script&lang=js"
export * from "./editdialog.vue?vue&type=script&lang=js"
import style0 from "./editdialog.vue?vue&type=style&index=0&id=457e9dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457e9dda",
  null
  
)

export default component.exports